import { Link, useNavigate } from 'react-router-dom'

import Button from '../ui/Button/Button'
import styles from './CampaignPartners.module.scss'
import DataNotfound from '../DataNotfound/DataNotfound'

import arrowUpRight from '../../assets/images/arrowUpRight.svg'
import classNames from 'classnames'
import { getImageUrl, isArabic } from '../../utils'
import Markdown from '../Markdown/Markdown'
import useIsMobile from '../../hooks/useIsMobile'
import { BASE_APP_URL } from '../../Contansts'
import { useLanguage } from '../../context/LangaugeContextProvider/LangaugeContextProvider'

const CampaignPartners = ({ sectiondata }) => {
  let isMobile = useIsMobile()
  let navigate = useNavigate()
  const { language } = useLanguage()

  const handleNavigation = (url, isExternal, isScrollable) => {
    if (isExternal) window.open(url, '_blank', 'noopener,noreferrer')
    else if (isScrollable) {
      let element = document.getElementById(url)
      if (element) {
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY
        window?.scrollTo({
          top: elementPosition - 110,
          behavior: 'smooth',
          block: 'start',
        })
      }
    } else navigate(url)
  }

  const renderLogos = (logos) => {
    return (
      <div className={styles['logosWrapper']}>
        {logos?.map((item) => {
          return (
            <div className={styles['imageContainer']} key={item?.id}>
              <img src={getImageUrl(item)} alt={item?.alternativeText} />
            </div>
          )
        })}
      </div>
    )
  }

  const LogoSection = ({ data }) => {
    return (
      <div className={styles['logoSectionContainer']}>
        <div className={styles['logoSectionWrapper']}>
          <div>
            {renderLogos(data?.payment_logos)}
            {data?.partner_text && (
              <div
                className={classNames(
                  styles['partnersDescription'],
                  'text-start pt-2'
                )}
              >
                {data?.partner_text}
              </div>
            )}
          </div>
          <div className="flex">{renderLogos(data?.partner_logos)}</div>
        </div>
      </div>
    )
  }

  const LinksSection = ({ data }) => {
    return (
      <div className={styles['partnersLinks']}>
        {data?.links?.map((button) => {
          return (
            <Button
              aria-label={button?.label}
              classname={classNames(
                styles.links,
                isArabic(language?.code) ? styles.ar_links : ''
              )}
              buttonDetails={button}
              text={button?.label}
              handleClick={() =>
                handleNavigation(
                  button?.path,
                  button?.isExternal,
                  button?.isScrollable
                )
              }
            >
              <img
                src={arrowUpRight}
                alt={button?.label}
                className={styles.btnImg}
              />
            </Button>
          )
        })}
      </div>
    )
  }

  const AcceptanceSection = ({ data }) => {
    return (
      <div className={styles.bottomContainer}>
        {data?.acceptance_title && (
          <div className={classNames(styles['partnersDescription'], 'mt-4')}>
            {data?.acceptance_title}
          </div>
        )}
        <div className={styles.benefitsCardContainer}>
          {data?.acceptance_cards?.map((item) => (
            <div key={item?.id}>
              <img
                src={getImageUrl(item)}
                alt={item?.alternativeText}
                className={styles.benefitsImg}
              />
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <>
      {sectiondata && sectiondata?.length > 0 ? (
        <div className={styles['partnersWrapper']}>
          {sectiondata?.map((data) => {
            return (
              <div className={styles.bgColor}>
                <div
                  className={classNames(
                    'page-container',
                    styles['partnersConatiner']
                  )}
                >
                  <LogoSection data={data} />

                  {data?.description && (
                    <Markdown
                      content={data?.description}
                      className={styles['partnersDescription']}
                    />
                  )}

                  {data?.links && data?.links?.length ? (
                    <LinksSection data={data} />
                  ) : null}

                  {data?.info && (
                    <div className={styles['info']}>{data.info}</div>
                  )}

                  <AcceptanceSection data={data} />

                  {data?.stripe_image_web?.url &&
                    data?.stripe_image_mobile?.url && (
                      <div className="mt-4 flex justify-center">
                        <img
                          className="max-h-[16rem] sm:max-h-[26.375rem] w-[100%]"
                          src={getImageUrl(
                            isMobile
                              ? data?.stripe_image_mobile
                              : data?.stripe_image_web
                          )}
                          alt={
                            isMobile
                              ? data?.stripe_image_mobile?.alternativeText
                              : data?.stripe_image_web?.alternativeText
                          }
                        />
                      </div>
                    )}

                  {data?.decals_pdf?.url &&
                    data?.image_link_web?.url &&
                    data?.image_link_mobile?.url && (
                      <Link
                        to={BASE_APP_URL + data?.decals_pdf?.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-4 flex justify-center"
                        title="Open the document in new tab"
                      >
                        <img
                          src={getImageUrl(
                            isMobile
                              ? data?.image_link_mobile
                              : data?.image_link_web
                          )}
                          alt={
                            isMobile
                              ? data?.image_link_mobile?.alternativeText
                              : data?.image_link_web?.alternativeText
                          }
                        />
                      </Link>
                    )}
                </div>
              </div>
            )
          })}
        </div>
      ) : (
        <DataNotfound description={''} />
      )}
    </>
  )
}

export default CampaignPartners
